/**
 * 모델명을 개발자용 닉네임으로 변환
 * 사용자에게 실제 모델명을 숨기기 위해 사용
 */

// 모델명 → 닉네임 매핑 (개발자만 알 수 있도록)
const MODEL_NICKNAME_MAP = {
  // Gemini 모델
  'gemini-3-flash-preview': 'g3f',             // ⭐ Gemini 3.0 Flash (2025.12.17 출시, 속도+추론)
  'gemini-3-pro-preview': 'g3p',               // ⭐ Gemini 3.0 Pro (2025.11.18 출시, 추론 우선)
  'gemini-2.5-flash': 'g2',                    // Gemini 2.5 Flash (빠른 속도)
  'gemini-2.5-pro': 'g2.5p',     // ⭐ Gemini 2.5 Pro (Stable)
  'gemini-2.0-flash-exp': 'g2f',
  'gemini-1.5-flash': 'g1',
  'gemini-1.5-pro': 'g1p',
  // Claude 모델
  'claude-sonnet-4-5': 'cs4',
  'claude-sonnet': 'cs4',
  'claude-haiku': 'ch',
  // Datalab 모델
  'datalab-marker': 'dm',
  'datalab-ocr': 'do',
  // DeepSeek 모델
  'deepseek': 'ds',
  // 🔮 Mistral 모델
  'mistral-ocr': 'mis',
};

// 닉네임 → 모델명 매핑 (역변환용)
const NICKNAME_MODEL_MAP = Object.fromEntries(
  Object.entries(MODEL_NICKNAME_MAP).map(([model, nickname]) => [nickname, model])
);

/**
 * 모델명을 닉네임으로 변환
 * @param {string} modelName - 원본 모델명 (예: 'gemini-2.5-flash')
 * @returns {string} 닉네임 (예: 'g2')
 */
export function getModelNickname(modelName) {
  if (!modelName) return '';
  return MODEL_NICKNAME_MAP[modelName] || modelName;
}

/**
 * 닉네임을 모델명으로 변환 (관리자용)
 * @param {string} nickname - 닉네임 (예: 'g2')
 * @returns {string} 원본 모델명 (예: 'gemini-2.5-flash')
 */
export function getModelName(nickname) {
  if (!nickname) return '';
  return NICKNAME_MODEL_MAP[nickname] || nickname;
}

/**
 * 모델명 표시 (UI용)
 * @param {string} modelName - 원본 모델명
 * @param {boolean} showFullName - true면 원본 모델명, false면 닉네임 (기본값: false)
 * @returns {string} 표시할 모델명
 */
export function formatModelName(modelName, showFullName = false) {
  if (!modelName) return '';
  return showFullName ? modelName : getModelNickname(modelName);
}

/**
 * source 필드에서 모델명 추출 및 닉네임 변환
 * @param {string|object} source - source 필드 (문자열 또는 객체)
 * @returns {string} 닉네임
 */
export function getSourceNickname(source) {
  if (!source) return '';

  // source가 객체인 경우
  if (typeof source === 'object') {
    const modelName = source.model || source.name || '';
    return getModelNickname(modelName);
  }

  // source가 문자열인 경우
  return getModelNickname(source);
}

/**
 * 모든 모델 닉네임 매핑 반환 (설정 화면용)
 * @returns {Object} { modelName: nickname }
 */
export function getAllModelNicknames() {
  return { ...MODEL_NICKNAME_MAP };
}

